import { computed as o, openBlock as s, createBlock as a, resolveDynamicComponent as b, normalizeStyle as i, withCtx as n, renderSlot as u } from "vue";
import t from "./design-system.es153.js";
/* empty css                    */
import f from "./design-system.es128.js";
const c = /* @__PURE__ */ Object.assign({
  name: "DsBleed"
}, {
  __name: "Bleed",
  props: {
    /**
         * HTML tag to render the component as
         */
    as: {
      type: String,
      default: "div"
    },
    /**
         * Bleed used by all sides
         */
    bleed: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    /**
         * Bleed used by the x-axis
         */
    bleedX: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    /**
         * Bleed used by the y-axis
         */
    bleedY: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    bleedTop: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    bleedRight: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    bleedBottom: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    bleedLeft: {
      type: String,
      default: null,
      validator: (d) => t.includes(d)
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },
  setup(d) {
    const e = d, r = o(() => {
      const l = {
        "--ds-bleed-top": "0rem",
        "--ds-bleed-bottom": "0rem",
        "--ds-bleed-left": "0rem",
        "--ds-bleed-right": "0rem"
      };
      return e.bleed && (l["--ds-bleed-top"] = `var(--ds-${e.bleed})`, l["--ds-bleed-bottom"] = `var(--ds-${e.bleed})`, l["--ds-bleed-left"] = `var(--ds-${e.bleed})`, l["--ds-bleed-right"] = `var(--ds-${e.bleed})`), e.bleedX && (l["--ds-bleed-left"] = `var(--ds-${e.bleedX})`, l["--ds-bleed-right"] = `var(--ds-${e.bleedX})`), e.bleedY && (l["--ds-bleed-top"] = `var(--ds-${e.bleedY})`, l["--ds-bleed-bottom"] = `var(--ds-${e.bleedY})`), e.bleedTop && (l["--ds-bleed-top"] = `var(--ds-${e.bleedTop})`), e.bleedRight && (l["--ds-bleed-right"] = `var(--ds-${e.bleedRight})`), e.bleedBottom && (l["--ds-bleed-bottom"] = `var(--ds-${e.bleedBottom})`), e.bleedLeft && (l["--ds-bleed-left"] = `var(--ds-${e.bleedLeft})`), e.backgroundColor && (l.backgroundColor = `var(--ds-color-${e.backgroundColor})`), l;
    });
    return (l, p) => (s(), a(b(d.as), {
      class: "ds-bleed",
      style: i(r.value)
    }, {
      default: n(() => [
        u(l.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), $ = /* @__PURE__ */ f(c, [["__scopeId", "data-v-048de4c0"]]);
export {
  $ as default
};
//# sourceMappingURL=design-system.es36.js.map
